<template>
  <div class="page-content--body">

    <div class="page-content--body-right profile-worker">
      <v-card outlined>
        <v-card-text>
          <div class="profile-worker--info">
            <div class="profile-worker--info-data">
              <div class="profile-worker--info-data-photo">
                <img src="@/assets/images/user-photo.jpg" alt="">
              </div>
              <div class="profile-worker--info-data-wrap">
                <div class="profile-worker--info-data-name">Антонова Екатерина</div>
                <div class="profile-worker--info-data-rating">
                  <v-rating
                    v-model="rating"
                    background-color="orange lighten-3"
                    color="orange"
                    readonly
                    size="16"
                  ></v-rating>
                </div>
                <div class="profile-worker--info-data-city">
                  Россия, Пермский край, г Пермь
                </div>
                <div class="profile-worker--info-data-experience">
                  <div class="ico-info"><img src="@/assets/images/ico-user-info1.svg" alt=""></div>
                  Опыт с технологиями REHAU: более 5 лет
                </div>
                <div class="profile-worker--info-data-legal">
                  <div class="ico-info"><img src="@/assets/images/ico-user-info2.svg" alt=""></div>
                  Монтажник с юридическим лицом
                </div>
                <router-link to="" class="profile-worker--info-data-link">Профиль</router-link>
              </div>
            </div>
            <div class="profile-worker--info-types">
              <div class="profile-worker--info-types-objects">
                <div class="object-types--title">Типы объектов:</div>
                <div class="object-types--icons">
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type01.svg" alt="">
                      </template>
                      <span>Маляр</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type02.svg" alt="">
                      </template>
                      <span>Штукатур</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type03.svg" alt="">
                      </template>
                      <span>Усач</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type04.svg" alt="">
                      </template>
                      <span>Мозг</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type05.svg" alt="">
                      </template>
                      <span>База данных</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
              <div class="profile-worker--info-types-objects">
                <div class="object-types--title">Специализации:</div>
                <div class="object-types--icons">
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type01.svg" alt="">
                      </template>
                      <span>Маляр</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type02.svg" alt="">
                      </template>
                      <span>Штукатур</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type03.svg" alt="">
                      </template>
                      <span>Усач</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type04.svg" alt="">
                      </template>
                      <span>Мозг</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type05.svg" alt="">
                      </template>
                      <span>База данных</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>

            </div>
            <div class="profile-worker--info-button">
              <v-btn icon class="more-btn">
                <img src="@/assets/images/ico-points.svg" alt="">
              </v-btn>
            </div>
          </div>
          <div class="profile-worker--about">
            <div class="profile-worker--about-title">О себе:</div>
            <div class="profile-worker--about-text">
            монтаж и замена электрики, сантехники, обслуживание мелких, средних предприятий бизнеса в городе и области. нал, безнал, выдаются чеки как самозанято  РЕМОНТ, монтаж и замена электрики, сантехники, обслуживание мелких монтаж и замена электрики, сантехники, обслуживание мелких, средних предприятий бизнеса в городе и области. нал, безнал, выдаются чеки как самозанято  РЕМОНТ, монтаж и замена электрики, сантехники, обслуживание мелких
            </div>
          </div>
        </v-card-text>

        <v-card-text class="profile-worker--footer">
          <v-rating
            v-model="ratingHeart"
            full-icon="mdi-heart"
            empty-icon="mdi-heart-outline"
            half-icon="$mdi-heart-half-full"
            color="#E93535"
            background-color="grey"
            size="20"
          ></v-rating>
          <v-btn class="btn-small btn-blue" color="primary">Отправить заявку</v-btn>
        </v-card-text>
      </v-card>

      <div class="portfolio">
        <div class="portfolio--cards">
          <div class="portfolio--cards-point">
            <div class="portfolio--cards-point-status">
              <div class="portfolio--cards-point-status--label label-green">
                Публичная
              </div>
              <div class="portfolio--cards-point-status--button">
                <v-btn icon class="more-btn">
                  <img src="@/assets/images/ico-points.svg" alt="">
                </v-btn>
              </div>
            </div>
            <div class="portfolio--cards-point-img">
              <img src="../../../assets/images/portfolio-img05.jpg" alt="">
            </div>
            <div class="portfolio--cards-point-title">Монтаж очень сложной штуки</div>
            <div class="portfolio--cards-point-location">
              <img src="@/assets/images/ico-location.svg" alt="">
              <span>Москва </span>
            </div>
            <v-dialog
              v-model="dialog1"
              max-width="800px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="portfolio--cards-point-more"
                >
                  Редактировать
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="card-title">
                  Редактирование
                </v-card-title>
                <v-card-text>
                  Контент находится в стадии разработки
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <div class="portfolio--cards-point">
            <div class="portfolio--cards-point-status">
              <div class="portfolio--cards-point-status--label label-grey">
                СКРЫТАЯ
              </div>
              <div class="portfolio--cards-point-status--button">
                <v-btn icon class="more-btn">
                  <img src="@/assets/images/ico-points.svg" alt="">
                </v-btn>
              </div>
            </div>
            <div class="portfolio--cards-point-img">
              <img src="../../../assets/images/portfolio-img04.jpg" alt="">
            </div>
            <div class="portfolio--cards-point-title">Монтаж очень сложной штуки</div>
            <div class="portfolio--cards-point-location">
              <img src="@/assets/images/ico-location.svg" alt="">
              <span>Москва </span>
            </div>
            <v-dialog
              v-model="dialog2"
              max-width="800px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="portfolio--cards-point-more"
                >
                  Редактировать
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="card-title">
                  Редактирование
                </v-card-title>
                <v-card-text>
                  Контент находится в стадии разработки
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <div class="portfolio--cards-point">
            <div class="portfolio--cards-point-status">
              <div class="portfolio--cards-point-status--label label-green">
                Публичная
              </div>
              <div class="portfolio--cards-point-status--button">
                <v-btn icon class="more-btn">
                  <img src="@/assets/images/ico-points.svg" alt="">
                </v-btn>
              </div>
            </div>
            <div class="portfolio--cards-point-img">
              <img src="../../../assets/images/portfolio-img03.jpg" alt="">
            </div>
            <div class="portfolio--cards-point-title">Монтаж очень сложной штуки</div>
            <div class="portfolio--cards-point-location">
              <img src="@/assets/images/ico-location.svg" alt="">
              <span>Москва </span>
            </div>
            <v-dialog
              v-model="dialog3"
              max-width="800px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="portfolio--cards-point-more"
                >
                  Редактировать
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="card-title">
                  Редактирование
                </v-card-title>
                <v-card-text>
                  Контент находится в стадии разработки
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <div class="portfolio--cards-point">
            <div class="portfolio--cards-point-status">
              <div class="portfolio--cards-point-status--label label-green">
                Публичная
              </div>
              <div class="portfolio--cards-point-status--button">
                <v-btn icon class="more-btn">
                  <img src="@/assets/images/ico-points.svg" alt="">
                </v-btn>
              </div>
            </div>
            <div class="portfolio--cards-point-img">
              <img src="../../../assets/images/portfolio-img02.jpg" alt="">
            </div>
            <div class="portfolio--cards-point-title">Монтаж очень сложной штуки</div>
            <div class="portfolio--cards-point-location">
              <img src="@/assets/images/ico-location.svg" alt="">
              <span>Москва </span>
            </div>
            <v-dialog
              v-model="dialog4"
              max-width="800px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="portfolio--cards-point-more"
                >
                  Редактировать
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="card-title">
                  Редактирование
                </v-card-title>
                <v-card-text>
                  Контент находится в стадии разработки
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <div class="portfolio--cards-point">
            <div class="portfolio--cards-point-status">
              <div class="portfolio--cards-point-status--label label-green">
                Публичная
              </div>
              <div class="portfolio--cards-point-status--button">
                <v-btn icon class="more-btn">
                  <img src="@/assets/images/ico-points.svg" alt="">
                </v-btn>
              </div>
            </div>
            <div class="portfolio--cards-point-img">
              <img src="../../../assets/images/portfolio-img01.jpg" alt="">
            </div>
            <div class="portfolio--cards-point-title">Монтаж очень сложной штуки</div>
            <div class="portfolio--cards-point-location">
              <img src="@/assets/images/ico-location.svg" alt="">
              <span>Москва </span>
            </div>
            <v-dialog
              v-model="dialog5"
              max-width="800px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="portfolio--cards-point-more"
                >
                  Редактировать
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="card-title">
                  Редактирование
                </v-card-title>
                <v-card-text>
                  Контент находится в стадии разработки
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page8',
  data() {
    return {
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      rating: 5,
      ratingHeart: 3,
    };
  },
  computed: {

  },

  methods: {

  },
};
</script>

<style lang="scss" src="./style.scss"/>
